<div class="loginpage">
    <div class="loginContainer">
        <div style="text-align:center;">
            <a href="http://www.bsrm.com" target="_blank" class="brand-logo">
                <img class="responsive-img" src="../../../assets/images/bsrm-logo.png" width="100%" alt="">
            </a>
        </div>
        <div style="margin-top:16px !important;">
            <form [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)">
                <div class="form-group">
                    <div class="input-group">
                        <dx-text-box formControlName="UserId" placeholder="Enter your account number">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Please provide your account number.">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                        <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
                    </div>

                </div>

                <div class="form-group">
                    <div class="input-group">
                        <dx-text-box formControlName="Password" placeholder="Enter your password" mode="password">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Please provide password.">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                        <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
                    </div>
                </div>

                <div class="form-group">
                    <dx-button style="background-color:#ffcb05 !important;" type="success" width="100%" text="Login"
                        (onClick)="login(loginForm.value)"></dx-button>
                </div>

                <div *ngIf="errorMsg?.length > 0" style="padding-top:16px;" class="form-group alert alert-danger">
                    {{errorMsg}}
                </div>




            </form>
        </div>

        <dx-button
        icon="glyphicon glyphicon-edit"
        text="Forgot Password "
        (onClick)="ForgotPassword(loginForm.value)">
    </dx-button>
    </div>
</div>